"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCache = clearCache;
exports.RemoteFileWithRangeCache = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _httpRangeFetcher = require("http-range-fetcher");

var _buffer = require("buffer");

var _genericFilehandle = require("generic-filehandle");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fetchers = {};

function binaryRangeFetch(url, start, end) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var fetcher = fetchers[url];

  if (!fetcher) {
    throw new Error("fetch not registered for ".concat(url));
  }

  return fetcher(url, start, end, options);
}

var globalRangeCache = new _httpRangeFetcher.HttpRangeFetcher({
  fetch: binaryRangeFetch,
  size: 500 * Math.pow(1024, 2),
  // 500MiB
  chunkSize: 128 * 124,
  // 128KiB
  maxFetchSize: 100 * Math.pow(1024, 2),
  // 100MiB
  minimumTTL: 24 * 60 * 60 * 1000 // 1 day

});

function clearCache() {
  globalRangeCache.reset();
}

var RemoteFileWithRangeCache = /*#__PURE__*/function (_RemoteFile) {
  (0, _inherits2.default)(RemoteFileWithRangeCache, _RemoteFile);

  var _super = _createSuper(RemoteFileWithRangeCache);

  function RemoteFileWithRangeCache() {
    (0, _classCallCheck2.default)(this, RemoteFileWithRangeCache);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(RemoteFileWithRangeCache, [{
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, init) {
        var requestHeaders, range, _ref, _ref2, rangeParse, _rangeParse, _start, _end, s, e, response, headers;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!fetchers[String(url)]) {
                  fetchers[String(url)] = this.fetchBinaryRange.bind(this);
                } // if it is a range request, route it through the range cache


                requestHeaders = init && init.headers;

                if (requestHeaders) {
                  if (requestHeaders instanceof Headers) {
                    range = requestHeaders.get('range');
                  } else if (Array.isArray(requestHeaders)) {
                    ;
                    _ref = requestHeaders.find(function (_ref3) {
                      var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
                          key = _ref4[0];

                      return key === 'range';
                    }) || [undefined, undefined];
                    _ref2 = (0, _slicedToArray2.default)(_ref, 2);
                    range = _ref2[1];
                  } else {
                    range = requestHeaders.range;
                  }
                }

                if (!range) {
                  _context.next = 14;
                  break;
                }

                rangeParse = /bytes=(\d+)-(\d+)/.exec(range);

                if (!rangeParse) {
                  _context.next = 14;
                  break;
                }

                _rangeParse = (0, _slicedToArray2.default)(rangeParse, 3), _start = _rangeParse[1], _end = _rangeParse[2];
                s = parseInt(_start, 10);
                e = parseInt(_end, 10);
                _context.next = 11;
                return globalRangeCache.getRange(url, s, e - s + 1, {
                  signal: init && init.signal
                });

              case 11:
                response = _context.sent;
                headers = response.headers;
                return _context.abrupt("return", new Response(response.buffer, {
                  status: 206,
                  headers: headers
                }));

              case 14:
                return _context.abrupt("return", (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteFileWithRangeCache.prototype), "fetch", this).call(this, url, init));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "fetchBinaryRange",
    value: function () {
      var _fetchBinaryRange = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, start, end) {
        var options,
            requestDate,
            requestHeaders,
            res,
            responseDate,
            errorMessage,
            hint,
            headers,
            _iterator,
            _step,
            _step$value,
            k,
            v,
            arrayBuffer,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                requestDate = new Date();
                requestHeaders = _objectSpread(_objectSpread({}, options.headers), {}, {
                  range: "bytes=".concat(start, "-").concat(end)
                });
                _context2.next = 5;
                return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteFileWithRangeCache.prototype), "fetch", this).call(this, url, _objectSpread(_objectSpread({}, options), {}, {
                  headers: requestHeaders
                }));

              case 5:
                res = _context2.sent;
                responseDate = new Date();

                if (!(res.status !== 206)) {
                  _context2.next = 11;
                  break;
                }

                errorMessage = "HTTP ".concat(res.status, " (").concat(res.statusText, ") when fetching ").concat(url, " bytes ").concat(start, "-").concat(end);
                hint = ' (should be 206 for range requests)';
                throw new Error("".concat(errorMessage).concat(res.status === 200 ? hint : ''));

              case 11:
                // translate the Headers object into a regular key -> value object.
                // will miss duplicate headers of course
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                headers = {};
                _iterator = _createForOfIteratorHelper(res.headers.entries());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = (0, _slicedToArray2.default)(_step.value, 2), k = _step$value[0], v = _step$value[1];
                    headers[k] = v;
                  } // return the response headers, and the data buffer

                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context2.next = 16;
                return res.arrayBuffer();

              case 16:
                arrayBuffer = _context2.sent;
                return _context2.abrupt("return", {
                  headers: headers,
                  requestDate: requestDate,
                  responseDate: responseDate,
                  buffer: _buffer.Buffer.from(arrayBuffer)
                });

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBinaryRange(_x3, _x4, _x5) {
        return _fetchBinaryRange.apply(this, arguments);
      }

      return fetchBinaryRange;
    }()
  }]);
  return RemoteFileWithRangeCache;
}(_genericFilehandle.RemoteFile);

exports.RemoteFileWithRangeCache = RemoteFileWithRangeCache;